import { render, staticRenderFns } from "./wisdomGarden.vue?vue&type=template&id=c3948c2e&scoped=true"
import script from "./wisdomGarden.vue?vue&type=script&lang=js"
export * from "./wisdomGarden.vue?vue&type=script&lang=js"
import style0 from "./wisdomGarden.vue?vue&type=style&index=0&id=c3948c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3948c2e",
  null
  
)

export default component.exports